import { render, staticRenderFns } from "./course-complaints.vue?vue&type=template&id=280417f8&scoped=true&"
import script from "./course-complaints.vue?vue&type=script&lang=js&"
export * from "./course-complaints.vue?vue&type=script&lang=js&"
import style0 from "./course-complaints.vue?vue&type=style&index=0&id=280417f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280417f8",
  null
  
)

export default component.exports